var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../typings/tsd.d.ts" />
var warsApp;
(function (warsApp) {
    var services;
    (function (services) {
        var ManageScheduledResourcesService = /** @class */ (function (_super) {
            __extends(ManageScheduledResourcesService, _super);
            function ManageScheduledResourcesService(injectedBreeze, $q, $http) {
                var _this = _super.call(this, injectedBreeze, $q) || this;
                _this.$http = $http;
                return _this;
            }
            ManageScheduledResourcesService.prototype.createNewScheduledResourceConfiguration = function (codeGroup) {
                var scheduledResourceConfig = this.createNewEntity("ScheduledResourceConfiguration", { myParentCodeGroup: codeGroup });
                scheduledResourceConfig.uniqueIdentifier = services.UtilityService.generateGuidComb();
                return scheduledResourceConfig;
            };
            ManageScheduledResourcesService.prototype.getAllScheduledResourcesForProcessConfiguration = function (id) {
                var query = this.breezeModule.EntityQuery
                    .from("ScheduledResourceConfigurations")
                    .where("processConfiguration_id", "==", id);
                return this.executeQuery(query);
            };
            ManageScheduledResourcesService.prototype.getAllScheduledResourcesForProcessConfigurationAndSystem = function (id) {
                var pred = this.breezeModule.Predicate
                    .create('processConfiguration_id', '==', id)
                    .or('processConfiguration_id', '==', null);
                var query = this.breezeModule.EntityQuery
                    .from("ScheduledResourceConfigurations")
                    .where(pred);
                return this.executeQuery(query);
            };
            ManageScheduledResourcesService.prototype.checkScheduledResource = function (processId, formDataId, schemaPropertyId, scheduleEntry) {
                var d = this.$q.defer();
                var payload = {
                    processId: processId,
                    FormDataId: formDataId,
                    schemaPropertyId: schemaPropertyId,
                    scheduleEntry: scheduleEntry
                };
                this.$http.post('./api/ScheduledResource/CheckSchedule', payload).then(function (r) { d.resolve(r.data); });
                return d.promise;
            };
            return ManageScheduledResourcesService;
        }(services.DataService));
        services.ManageScheduledResourcesService = ManageScheduledResourcesService;
    })(services = warsApp.services || (warsApp.services = {}));
})(warsApp || (warsApp = {}));
warsApp.registerService('ManageScheduledResourcesService', ['breeze', '$q', '$http']);
